<section class="content">
  <h1>Homepage-Karussell</h1>

  <button mat-flat-button color="primary" (click)="openSliderForm()">Neues Element</button>

  @if (loading()) {
    <div class="mt-xl">
      <mat-spinner diameter="50"></mat-spinner>
      <p>Laden Daten...</p>
    </div>
  } @else {
    <div class="table-container">
      <table mat-table [dataSource]="dataSlides" class="table-status">
        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element">
            <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" class="{{element.status}}">radio_button_checked</mat-icon>
          </td>
        </ng-container>

        <!-- Title Column -->
        <ng-container matColumnDef="title">
          <th mat-header-cell *matHeaderCellDef> Titel </th>
          <td mat-cell *matCellDef="let element"> {{ element.title }} </td>
        </ng-container>

        <!-- Link Column -->
        <ng-container matColumnDef="link">
          <th mat-header-cell *matHeaderCellDef> Link </th>
          <td mat-cell *matCellDef="let element">
            @if (element.link) {
              <a href="{{ element.link }}" target="_blank" matTooltip="{{ element.link }}">
                <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" >link</mat-icon>
              </a>
            } @else {
              <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" >link_off</mat-icon>
            }

          </td>
        </ng-container>

        <!-- Image Column -->
        <ng-container matColumnDef="image">
          <th mat-header-cell *matHeaderCellDef> Bild </th>
          <td mat-cell *matCellDef="let element">
            <mat-icon
              fontSet="material-symbols-outlined"
              aria-hidden="false"
              class="cursor-pointer"
              (click)="showImagePreview(element.imagePath)">image</mat-icon>
          </td>
        </ng-container>

        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Datum </th>
          <td mat-cell *matCellDef="let element"> {{ element.start }} - {{ element.end  }}</td>
        </ng-container>


        <!-- Order Column -->
        <ng-container matColumnDef="order">
          <th mat-header-cell *matHeaderCellDef> Order </th>
          <td mat-cell *matCellDef="let element"> {{ element.order }} </td>
        </ng-container>


        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button color="primary" (click)="editSlide(element)">
              <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" >edit</mat-icon>
            </button>
            <button mat-icon-button color="warn" (click)="deleteSlide(element)">
              <mat-icon fontSet="material-symbols-outlined" aria-hidden="false">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsSlides"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsSlides;" matRipple></tr>
      </table>

      <!--    <mat-paginator #paginator-->
      <!--      [pageSizeOptions]="[5, 10, 20]"-->
      <!--      showFirstLastButtons>-->
      <!--    </mat-paginator>-->
    </div>
  }
</section>
